import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthTokenInterceptor } from '../../common/interceptors/auth.token.interceptors';
import { PaginatorService, UserService } from '../../services';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ProBarComponent } from './pro-bar/pro-bar.component';
import { AuthGuard } from 'src/app/common/guards';
import { PasswordChangeComponent } from '../user/password-change/password-change.component';
import { ResetpasswordrequestComponent } from './forgotpassword/resetpasswordrequest/resetpasswordrequest.component';
import { ResetpasswordComponent } from './forgotpassword/resetpassword/resetpassword.component';
import { LoginService } from 'src/app/services/login.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    PaginatorComponent,
    PasswordChangeComponent,
    ProBarComponent,
    ResetpasswordrequestComponent,
    ResetpasswordComponent,
  ],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    PaginatorService,
    UserService,
    LoginService,
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ResetpasswordrequestComponent,
    PasswordChangeComponent,
    HeaderComponent,
    FooterComponent,
    PaginatorComponent,
    ProBarComponent
  ]
})
export class SharedModule { }
